import { useIntl } from 'react-intl';
import {
  PromptSuggestionCategory,
  PromptSuggestionsChipCarousel,
} from '@rossum/components/prompt-suggestions-chip-carousel/PromptSuggestionsChipCarousel';
import {
  IconBell,
  IconBolt,
  IconCircleDashedCheck,
  IconEye,
  IconTag,
} from '@rossum/ui/icons/tabler';
import { SvgIcon } from '@rossum/ui/material';
import { promptSuggestionsCategories } from './prompt_suggestions';

type CategoryIconKey = (typeof promptSuggestionsCategories)[number]['icon'];

const categoryIconMap: Record<CategoryIconKey, React.ReactElement> = {
  automation: (
    <SvgIcon fontSize="large">
      <IconBolt />
    </SvgIcon>
  ),
  tagging: (
    <SvgIcon fontSize="large">
      <IconTag />
    </SvgIcon>
  ),
  notify: (
    <SvgIcon fontSize="large">
      <IconBell />
    </SvgIcon>
  ),
  validation: (
    <SvgIcon fontSize="large">
      <IconCircleDashedCheck />
    </SvgIcon>
  ),
  visibility: (
    <SvgIcon fontSize="large">
      <IconEye />
    </SvgIcon>
  ),
};

type RulesPromptSuggestionsChipCarouselProps = {
  onPromptSelect: (prompt: string) => void;
  disabled?: boolean;
  className?: string;
};

export const PromptSuggestions = ({
  onPromptSelect,
  disabled,
  className,
}: RulesPromptSuggestionsChipCarouselProps) => {
  const intl = useIntl();

  const categories: PromptSuggestionCategory<CategoryIconKey>[] =
    promptSuggestionsCategories.map(category => ({
      ...category,
      label: intl.formatMessage({
        id: `features.queueSettings.rules.promptSuggestions.categories.${category.icon}`,
      }),
    }));

  return (
    <PromptSuggestionsChipCarousel
      categories={categories}
      iconMap={categoryIconMap}
      onPromptSelect={onPromptSelect}
      disabled={disabled}
      className={className}
    />
  );
};
